"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asRecord = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const sanitizers_1 = require("@restless/sanitizers");
const asRecord = (asValue) => (value, path) => {
    if (typeof value !== 'object' || value === null) {
        return sanitizers_1.Result.error([{ path, expected: 'object' }]);
    }
    const results = {};
    const errors = [];
    for (const key in value) {
        const keyResult = (0, sanitizers_1.asString)(key, `${key} should be a string`);
        if (sanitizers_1.Result.isError(keyResult)) {
            errors.push(...keyResult.error);
        }
        const result = asValue(value[key], `${path}.${key}`);
        if (sanitizers_1.Result.isOk(result)) {
            results[key] = result.ok;
        }
        else {
            errors.push(...result.error);
        }
    }
    return errors.length > 0 ? sanitizers_1.Result.error(errors) : sanitizers_1.Result.ok(results);
};
exports.asRecord = asRecord;
//# sourceMappingURL=asRecord.js.map